const question = [
    {   id:1,
        name:"Have you delivered your best which you were capable of ?",
    },
    {   id:2,
        name:"Have the spirit of you conduct been harmonious and cooperative all the time",
        
    },
    {   id:3,
        name:"Have I permitted habit of procrastination to decrease any efficiency.",
        
    },
    {   id:4,
        name:"Has my relationship with my colleagues in work been pleasant or unpleasant ",
        
    },
    {   
       id:5,
       name:"Have I been open minded and tolerant in connections with all subject",
    },
    {   
        id:6,
        name:"Have I intemperate in any of my habits",
     },
     {   
        id:7,
        name:"Have I express either openly or secretly, any form of egotism.",
     },
     {
        id:8,
        name:"Have I followed habit of budgeting my time my expenses and my income and have I been conservative in these budget",
     },
      {
        id:9,   
        name:"How much time have I devoted to unprofitable effort which I might have used to better advantage"
      }     
]
export default question;